<template>
    <svg
        t="1610004405002"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="7388"
        :width="size"
        :height="size"
    >
        <path
            d="M512 64a448 448 0 1 0 0 896A448 448 0 0 0 512 64z m193.472 301.696l-210.56 292.032a31.808 31.808 0 0 1-51.712 0l-124.672-172.8a8 8 0 0 1 6.464-12.736h46.912c10.24 0 19.84 4.928 25.92 13.312L468.992 584.32l157.184-218.048a32 32 0 0 1 25.92-13.248h46.912c6.464 0 10.24 7.36 6.464 12.672z"
            fill="#bfa66d"
            p-id="7389"
            :width="size"
            :height="size"
        ></path>
    </svg>
</template>
<script>
export default {
    props: {
        size: {
            type: String,
            default: "10vw",
        },
    },
};
</script>
